import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

const Contact = () => {
  // Using Google Maps embed with q parameter (no API key required for basic embed)
const mapSrc =
  "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d239.84785627892802!2d74.50814703845344!3d15.879407332805888!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTXCsDUyJzQ1LjkiTiA3NMKwMzAnMjkuOCJF!5e0!3m2!1sen!2sin!4v1788263176180!5m2!1sen!2sin";
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800">Contact Us</h2>
          <p className="text-lg text-gray-600 mt-2">Visit us or reach out anytime</p>
        </div>

        {/* Map Section */}
        <div className="max-w-4xl mx-auto mb-12 rounded-xl overflow-hidden shadow-lg">
  <iframe
    title="Prathamesh Dairy Location"
    src={mapSrc}
    width="100%"
    height="400"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="strict-origin-when-cross-origin"
    className="w-full"
  />
</div>

        {/* Contact Info Cards */}
        <div className="flex flex-col md:flex-row justify-center gap-8 max-w-5xl mx-auto">
          {/* Address Card */}
          <div className="flex-1 bg-gray-50 p-6 rounded-lg shadow hover:shadow-md transition">
            <div className="flex items-center gap-3 mb-3">
              <MapPin className="text-blue-600" size={28} />
              <h3 className="font-semibold text-lg">Address</h3>
            </div>
            <p className="text-gray-600">
              CTS No. 4857/139A, 2 Main Road, Sadashiv Nagar, Last Bus Stop<br />
              Belgavi, Karnataka - 590019
            </p>
          </div>

          {/* Phone Card */}
          <div className="flex-1 bg-gray-50 p-6 rounded-lg shadow hover:shadow-md transition">
            <div className="flex items-center gap-3 mb-3">
              <Phone className="text-blue-600" size={28} />
              <h3 className="font-semibold text-lg">Phone</h3>
            </div>

            <p className="text-gray-700 font-medium">Prathamesh Y Patil</p>
            <p className="text-gray-600">+91 8277700089</p>

            <p className="text-gray-700 font-medium mt-3">Anuradha S Patil</p>
            <p className="text-gray-600">+91 8050530192</p>

            <p className="text-sm text-gray-500 mt-3">
              Open all 7 days • 7:00 AM – 10:00 PM
            </p>
          </div>

          {/* Email Card */}
          <div className="flex-1 bg-gray-50 p-6 rounded-lg shadow hover:shadow-md transition">
            <div className="flex items-center gap-3 mb-3">
              <Mail className="text-blue-600" size={28} />
              <h3 className="font-semibold text-lg">Email</h3>
            </div>
            <p className="text-gray-600 break-all">prathameshpatil528@gmail.com</p>
            <p className="text-sm text-gray-500 mt-1">For more inquiries</p>
          </div>
        </div>


      </div>
    </section>
  );
};

export default Contact;